import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TariffPage from "@/components/tariff/TariffPage.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TariffView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffPage))
}
}

})